import { render } from "./SurveyFrequency.vue?vue&type=template&id=9f0ee54e&scoped=true"
import script from "./SurveyFrequency.vue?vue&type=script&lang=ts"
export * from "./SurveyFrequency.vue?vue&type=script&lang=ts"

import "./SurveyFrequency.vue?vue&type=style&index=0&id=9f0ee54e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-9f0ee54e"

export default script